var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-flex',{staticClass:"icon",class:_vm.additionalClass},[(_vm.mimeType)?_c('v-icon',{attrs:{"color":_vm.mimeType.color}},[_vm._v("\n    "+_vm._s(_vm.mimeType.icon)+"\n  ")]):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }